module.exports = __webpack_public_path__ + "media/images/guideline/coupon-03-228397648d38ae95002a09094be01981.jpg";